import React, { Component } from 'react';

import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { AddSports, getLocationList, emailExist_check,
    hobbiesEdit, hobbiesReject, commonAPI } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { MOBILE_REGEX, URL_REGEX, BASEURL } from '../../constant.js';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

import Geocode from "react-geocode";
import { Multiselect } from 'multiselect-react-dropdown';
import SimpleReactValidator from 'simple-react-validator';
const url = BASEURL;
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

class verticalCampsEdit extends Component {
constructor(props) {
        super(props);
        this.state = {
            type_of_orgainsation: this.props.match.params.type,
            sub_type: [],
            pageid: '',
            location: 'Bengaluru',
            video_leaning: '',
            class_frequency: '',
            modeofpayment: '',
            categoryTypeList: [],
            categorySubTypeList: [],
            timingList: [],
            timing: '',
            std_ratio: [],
            ClassList: [],
            mopList: [],
            sub_categories: '',
            sub_types: [],
            noCategory: true,
            category: this.props.match.params.id,
            name_parm: this.props.match.params.type,
            categorySubTypeList1: [],
            latitude: '',
            longitude: '',
            other_rating: '',
            tutionList: [],
            tution_type: '',
            attachment_file: [],
            attachment_file_length: 0,
            attachment_fileName: [],
            from_time: '',
            from_time_cate: 'AM',
            to_time: '',
            to_time_cate: 'AM',
            edit_image: '',
            delete_array: [],
            keywords: '',
            location_list: [],
            tempBanner: '',
            has_trail: 0,
            trail_desc: '',
            partner_type: '',
            preview: false,
            edited_data: [],
            keywordsArr: [],
            edited: false
        }
        this.validator = new SimpleReactValidator({
            validators: {
                checkExist: {  // name the rule
                    message: 'The :attribute field is required.',
                    rule: (val, params, validator) => {
                        if (val == '' && this.state.edit_image == '') {
                            return false;
                        }
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                emailExist_check: {  // name the rule
                    message: 'The :attribute Already Exist.',
                    rule: (val, params, validator) => {
                        return this.state.isEmailValid;
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
                checkMobile: MOBILE_REGEX,
                checkUrl: URL_REGEX
            }
        });
        this.id = this.props.match.params.id;
        this.token = this.props.match.params.token;
        this.type = this.props.match.params.type;
        if (this.token) {
            this.infoDetails = this.infoDetails.bind(this);
            this.infoDetails();
        }
        this.loadFile = this.loadFile.bind(this)
        this.getKeywords();
        this.Cat_type(); this.tutionList(); this.getclass_frequency(); this.gettiming(); this.getpayment_type();
    }
    componentDidMount() {
        this.LocationDataList();
        let user_data = localStorage.getItem("user_data");
        let auth_data = JSON.parse(user_data);
        let vendor_id = auth_data.login_id;
        this.setState({
            login_id: vendor_id,
            role: auth_data.role,
        });
    }

    LocationDataList = async () => {
        try {
            const res = await getLocationList();
            if (res.status == 1) {
                console.log('location_list', res.results)

                this.setState({
                    location_list: res.results,
                    error: false
                });
            }

        } catch (error) {
            this.setState({ error: true });
        }
    };
    getKeywords = () => {
        commonAPI(JSON.stringify({ url: 'get_site_keywords', vertical:'camp' })).then((res) => {
            if (res.status === 1) {
                this.setState({
                    keywordsArr: res.results
                })
            }
        })
    }
    async infoDetails() {
        let response = await hobbiesEdit(JSON.stringify({ id: this.token }));
        if (response) {
            const data = response.data, edited_data = response.original;
            this.setState({
                about: data.about,
                pageid: data.id,
                addmission_fee: data.admit_fee,
                address: data.address,
                area: data.area,
                avg_anual_fee: data.avg_fee,
                class_frequency: data.class_frequency.split(','),
                country: data.country,
                email_id: data.email_id,
                establishment_Year: data.est_year,
                google_location: data.google_location,
                location: data.location,
                min_age: data.min_age,
                modeofpayment: data.modeofpayment,
                number_of_trainee: data.number_of_trainee,
                organisation_name: data.organisation_name,
                phone_number: data.phone_number,
                pincode: data.pincode,
                std_ratio: data.std_ratio.split(','),
                registration_no: data.registration_no,
                state: data.state,
                sub_categories: data.sub_categories.split(','),
                sub_types: data.sub_types.split(','),
                sub_type: data.sub_type.split(','),
                timing: data.time,
                video_leaning: data.video_leaning,
                website: data.website,
                tution_type: data.tution_type,
                partner_type: data.partner_type,
                other_info: data.other_info,
                cat_type1: (data.sub_type) ? true : false,
                cat_type: (data.type2) ? true : false,
                attachment_file: data.photo_arr,
                edit_image: data.images ? data.url + data.images : '',
                edit_photos: data.photos,
                photos: data.photos,
                images: data.images,
                keywords: data.keywords ? data.keywords.split(';') : [],
                from_time: data.from_time,
                to_time: data.to_time,
                from_time_cate: data.from_time_cate,
                to_time_cate: data.to_time_cate,
                has_trail: data.has_trail,
                trail_desc: data.trail_desc,
                longitude: data.longitude,
                latitude: data.latitude,
                other_rating: data.other_rating,
                edited: data.edited,
                edited_data: edited_data
            });
            this.Sub_Cat_type(data.sub_categories);
            this.Geocode_location(data.google_location);
        }
    }
    async tutionList() {
        let response = await FetchCall.getSchoolListDatas('tution_type');
        console.log(response);
        if (response) {
            this.setState({ tutionList: response.results });
        }
    }
    async Cat_type() {
        console.log('categoryTypeList', this.props.match.params.id);
        let response = await FetchCall.getSubCategory(this.props.match.params.id);
        if (response.status == 1) {
            this.setState({ categoryTypeList: response.results });
        } else {
            console.log('noCategory', 'in')
            this.setState({ noCategory: false });
        }
    }
    async Sub_Cat_type(id) {

        if (id != '') {
            let response = await FetchCall.getSubCategory(id);
            if (response.status == 1) {
                this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
            } else {
                this.setState({ categorySubTypeList: [], sub_types: [], cat_type: false, cat_type1: false, cat_type2: false });
            }
        } else {
            this.setState({ categorySubTypeList: [], sub_types: [], cat_type: false, cat_type1: false, cat_type2: false });
        }

    }
    async Sub_Cattype1(id) {
        if (id != '') {
            let response = await FetchCall.getSubCategory(id);
            if (response.status == 1) {
                this.setState({ categorySubTypeList1: response.results, cat_type1: true, cat_type2: false });
            } else {
                this.setState({ categorySubTypeList1: [], sub_type: [], cat_type1: false, cat_type2: false });
            }
        } else {
            this.setState({ categorySubTypeList1: [], sub_type: [], cat_type1: false, cat_type2: false });
        }

    }
    async getclass_frequency() {
        let response = await FetchCall.getSchoolListDatas('class_frequency');
        console.log(response);
        if (response.status == 1) {
            this.setState({ ClassList: response.results });
        }
    }
    async gettiming() {
        let response = await FetchCall.getSchoolListDatas('timing');
        console.log(response);
        if (response) {
            this.setState({ timingList: response.results });
        }
    }
    async getpayment_type() {
        let response = await FetchCall.getSchoolListDatas('payment_type');
        console.log(response);
        if (response) {
            this.setState({ mopList: response.results });
        }
    }
    UNSAFE_componentWillMount() {

    }
    componentDidUpdate() {
        //window.jQuery('.selectpicker').selectpicker('refresh');
    }

    handleSelect = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);

        this.setState({ [propName]: value });
        console.log('in', propName)
        // marshall_arts_other 
        if (propName === 'sub_type') {
            let filterValue = value.filter(item => item === 'others')
            console.log('filterValue', filterValue)
            if (filterValue[0] === 'others') {
                this.setState({
                    marshall_arts_other: true,
                })
                console.log('in')
            } else {
                console.log('out')
                this.setState({ marshall_arts_other: false, type_other: '' });
            }
        }
    };
    handleSelectSports = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);
        this.setState({ [propName]: value });
        // console.log('filterValue', value)

        // let filterValue = value.filter(item => item === 42)

        this.Sub_Cat_type(value);

        // if (value[0] == 42 || value[0] == 76 || value[0] == 77) {
        //     // this.Sub_Cat_type(value[0]);
        //     this.setState({
        //         // cat_type: true,
        //     })
        // } else {
        //     // console.log('1');
        //     this.setState({ cat_type: false, others_sports: '', sub_type: '' });
        // }

    }
    handleSelectCat1 = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);
        this.setState({ [propName]: value });

        this.Sub_Cattype1(value);
    }
    handleSelectCat2 = (e) => {
        const propName = e.target.name;
        const value = [...e.target.selectedOptions].map((item) => item.value);
        this.setState({ [propName]: value });

        this.Sub_Cattype2(value);
    }
    validateMail = (value, catgry, vendr_id, pageid) => {
        let name = 'email_id';
        let type_name = 'isEmailValid';
        let req = JSON.stringify({
            email_id: value,
            category: catgry,
            vendor_id: vendr_id,
            pageid: pageid
        });
        let res = emailExist_check(req).then(res => {
            console.log('valuee', res);
            if (res.status === 1) {
                this.setState({
                    [type_name]: false
                });
            } else {
                // return res.status;
                this.setState({
                    [type_name]: true
                });
            }
        });
    }
    handleNumberChange = (e) => {
        let regexp = /^[0-9\b]+$/
        let Mnumber = e.target.value;

        if (e.target.value === '' || regexp.test(e.target.value)) {
            this.setState({ [e.target.name]: Mnumber })
        }
        this.Geocode_location();
    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name == 'google_location')
            this.Geocode_location();
        const propName = e.target.name;
        // if (propName == 'email_id') {
        //     this.validateMail(e.target.value, 4, this.state.vendor_id,this.state.pageid);
        // }
        // const propName = e.target.name;
        // if (propName == 'google_location') {
        // this.Geocode_location();
        // }
    };
    onSelect = (selectedList) => {
        let keywords = [];
        selectedList.map((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }
    onRemove = (selectedList, removedItem) => {
        let keywords = [];
        selectedList.map((item, i) => {
            keywords.push(item)
        });
        this.setState({
            keywords: keywords,
        });
    }

    handleFile = (e) => {
        // this.Geocode_location();
        const propName = e.target.name;
        const files = e.target.files[0];
        this.setState({ [propName]: files });
        const reader = new FileReader();
        let img = '';
        let THIS = this;
        reader.addEventListener("load", function () {
            // convert image file to base64 string
            img = reader.result;
            THIS.setState({
                tempBanner: reader.result
            });
        }, false);

        if (files) {
            reader.readAsDataURL(files);
        } else {
            THIS.setState({
                tempBanner: ''
            });
        }
    };

    handleFileMultiple = (e) => {
        this.setState({ [e.target.name]: e.target.files });
    };

    Geocode_location(location = '') {
        Geocode.fromAddress(location ? location : this.state.google_location).then(
            response => {
                const { lat, lng } = response.results[0].geometry.location;
                if (lat && lng)
                    this.get_location(lat, lng);
            },
            error => {
                console.error(error);
            }
        );

    }


    get_location(lat, lng) {
        this.setState({
            latitude: lat,
            longitude: lng
        });
    }

    removeImage = e => {
        var delete_array = this.state.delete_array;
        delete_array.push(e)
        const updated = this.state.attachment_file.filter(item => item.name !== e)
        this.setState({
            attachment_file: updated,
            delete_array: delete_array,
        })
    }

    remove_img() {
        jQuery('#edit_image').remove();
    }
    loadFile(e) {
        var files = e.target.files
        this.setState({ attachment_file_length: files.length })
        if (files.length > 0) {
            jQuery('.upload-space').addClass('hide')
            jQuery('.upload-thumb').removeClass('hide')
            var fileArra = this.state.attachment_file

            //console.log('fileArra',fileArra)
            //var fileThumbArra = this.state.imgThumb;
            for (var i = 0; i < files.length; i++) {
                fileArra.push(e.target.files[i])
                this.setState({
                    selectedFile: URL.createObjectURL(e.target.files[i]),
                    attachment_file: fileArra
                })
            }
            //   this.clearValidationErr('attachment_file');
        }
    }
    handlePreview = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                preview: true
            })
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    render() {
        const { edited_data, edited } = this.state;
        this.validator.purgeFields();

        return (  
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Tuition Info Management</h4>
                                   
                   <div className="row">

                <div className="content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                  <div className="">
                      <div id="company-info" className="tab-pane active">
                        
                      <form onSubmit={this.handlePreview} className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Partner Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.partner_type}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="partner_type"
                                                                    title='Select'>
                                                                    <option value='1'>Institution</option>
                                                                    <option value='2'>Individuals</option>
                                                                </select>
                                                                {this.validator.message('Type', this.state.partner_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.registration_no != this.state.registration_no) && 'edited-field'}>
                                                                Registration No {this.state.user_type == 1 && <span className="astrick">*</span>} </label>
                                                            <input type="text" name="registration_no"
                                                                value={this.state.registration_no}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {
                                                                this.state.user_type == 1 &&
                                                                (
                                                                    this.validator.message('Registration No', this.state.registration_no, 'required', { className: 'text-danger' })
                                                                )
                                                            }
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.organisation_name != this.state.organisation_name) && 'edited-field'}>
                                                                {this.state.name_parm} Academy Name <span className="astrick">*</span></label>
                                                            <input type="text" name="organisation_name"
                                                                value={this.state.organisation_name}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message(this.state.name_parm + 'Academy Name', this.state.organisation_name, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        {
                                                            this.state.noCategory !== false &&
                                                            <div className="form-group col-md-4">
                                                                <label
                                                                    className={edited && (edited_data.sub_categories != this.state.sub_categories) && 'edited-field'}>
                                                                    {this.state.name_parm}<span className="astrick">*</span></label>
                                                                <div className='custom-select-drop dropdown'>
                                                                    <select
                                                                        multiple
                                                                        value={this.state.sub_categories}
                                                                        onChange={this.handleSelectSports}
                                                                        name="sub_categories"
                                                                        data-live-search="true"
                                                                        className='form-control selectpicker'
                                                                        title='Select' >
                                                                        {this.state.categoryTypeList.length > 0 &&
                                                                            this.state.categoryTypeList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.category_id} >
                                                                                        {item.category_name}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.cat_type == true &&
                                                            <div className="form-group col-md-4">
                                                                <label
                                                                    className={edited && (edited_data.sub_types != this.state.sub_types) && 'edited-field'}>
                                                                    {this.state.name_parm} Type<span className="astrick">*</span></label>
                                                                <div className='custom-select-drop dropdown'>
                                                                    <select
                                                                        multiple
                                                                        onChange={this.handleSelectCat1}
                                                                        name="sub_types"
                                                                        className='form-control selectpicker'
                                                                        title='Select'
                                                                        value={this.state.sub_types}
                                                                    >
                                                                        {this.state.categorySubTypeList.length > 0 &&
                                                                            this.state.categorySubTypeList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.category_id} >
                                                                                        {item.category_name}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message(this.state.name_parm + ' Type', this.state.sub_types, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.cat_type1 == true &&
                                                            <div className="form-group col-md-4">
                                                                <label
                                                                    className={edited && (edited_data.sub_type != this.state.sub_type) && 'edited-field'}>
                                                                    <span className="astrick"></span></label>
                                                                <div className='custom-select-drop dropdown'>
                                                                    <select
                                                                        multiple
                                                                        value={this.state.sub_type}
                                                                        onChange={this.handleSelectCat2}
                                                                        name="sub_type"
                                                                        className='form-control selectpicker'
                                                                        title='Select'
                                                                    >
                                                                        {this.state.categorySubTypeList1.length > 0 &&
                                                                            this.state.categorySubTypeList1.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.category_id} >
                                                                                        {item.category_name}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message('Type', this.state.sub_type, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>



                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Address Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.email_id != this.state.email_id) && 'edited-field'}>
                                                                Email Id <span className="astrick">*</span></label>
                                                            <input type="text" name="email_id"
                                                                value={this.state.email_id}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Email Id', this.state.email_id, 'emailExist_check', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Email Id', this.state.email_id, 'required|email', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.phone_number != this.state.phone_number) && 'edited-field'}>
                                                                Phone Number <span className="astrick">*</span></label>
                                                            <input type="text" name="phone_number"
                                                                value={this.state.phone_number}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Phone Number', this.state.phone_number, '', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Phone Number', this.state.phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.website != this.state.website) && 'edited-field'}>
                                                                Website <span className="astrick">*</span></label>
                                                            <input type="text" name="website"
                                                                value={this.state.website}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Website', this.state.website, '', { className: 'text-danger' })}
                                                            {/* {this.validator.message('Website', this.state.website, 'required|checkUrl', { className: 'text-danger' })} */}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.state != this.state.state) && 'edited-field'}>
                                                                State <span className="astrick">*</span></label>
                                                            <input type="text" name="state"
                                                                value={this.state.state}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('State', this.state.state, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.location != this.state.location) && 'edited-field'}>
                                                                Location <span className="astrick">*</span></label>
                                                            <select
                                                                name="location"
                                                                id="location"
                                                                onChange={this.handleSelect}
                                                                value={this.state.location}
                                                                className="form-control selectpicker"
                                                                title="Select"
                                                            >
                                                                {this.state.location_list.length > 0 &&
                                                                    this.state.location_list.map((item, i) => {
                                                                        return (
                                                                            <option value={item.location} >
                                                                                {item.location}
                                                                            </option>
                                                                        )
                                                                    })}
                                                            </select>
                                                            {this.validator.message('Location', this.state.location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.pincode != this.state.pincode) && 'edited-field'}>
                                                                Pincode<span className="astrick">*</span></label>
                                                            <input type="text" name="pincode"
                                                                value={this.state.pincode}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Pincode', this.state.pincode, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.address != this.state.address) && 'edited-field'}>
                                                                Address<span className="astrick">*</span></label>
                                                            <input type="text" name="address"
                                                                value={this.state.address}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Address', this.state.address, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.google_location != this.state.google_location) && 'edited-field'}>
                                                                Google Location Address<span className="astrick">*</span></label>
                                                            <input type="text" name="google_location"
                                                                value={this.state.google_location}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Google Location', this.state.google_location, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.latitude != this.state.latitude) && 'edited-field'}>
                                                                Latitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="latitude"
                                                                value={this.state.latitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Latitude', this.state.latitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.longitude != this.state.longitude) && 'edited-field'}>
                                                                Longitude
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="longitude"
                                                                value={this.state.longitude}
                                                                onChange={this.handleChange}

                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Longitude', this.state.longitude, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.other_rating != this.state.other_rating) && 'edited-field'}>
                                                                Google Rating
                                                                <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                step='0.01'
                                                                name="other_rating"
                                                                value={this.state.other_rating}
                                                                onChange={this.handleChange}
                                                                max='5'
                                                                className="form-control"
                                                            />
                                                            {this.validator.message('Google Rating', this.state.other_rating, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-12">
                                                            <label
                                                                className={edited && (edited_data.about != this.state.about) && 'edited-field'}>
                                                                About<span className="astrick">*</span></label>
                                                            <textarea type="text" name="about"
                                                                value={this.state.about}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('About', this.state.about, 'required', { className: 'text-danger' })}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Key Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.tution_type != this.state.tution_type) && 'edited-field'}>
                                                                Type<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.tution_type}
                                                                    onChange={this.handleSelect} className='form-control selectpicker'
                                                                    name="tution_type"
                                                                    title='Select'>
                                                                    {this.state.tutionList.length > 0 &&
                                                                        this.state.tutionList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Type', this.state.tution_type, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.class_frequency != this.state.class_frequency) && 'edited-field'}>
                                                                Class Frequency<span className="astrick">*</span></label>
                                                            <div className='custom-select-drop dropdown'>
                                                                <select
                                                                    multiple
                                                                    value={this.state.class_frequency}
                                                                    onChange={this.handleSelect}
                                                                    name="class_frequency"
                                                                    placeholder="select"
                                                                    className='form-control selectpicker'
                                                                    title='Select'>
                                                                    {this.state.ClassList.length > 0 &&
                                                                        this.state.ClassList.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id} >
                                                                                    {item.freq_name}
                                                                                </option>
                                                                            )
                                                                        })}
                                                                </select>
                                                                {this.validator.message('Class Frequency', this.state.class_frequency, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <label
                                                                className={edited && (edited_data.min_age != this.state.min_age) && 'edited-field'}>
                                                                Age Group<span className="astrick">*</span></label>
                                                            <input type="text" name="min_age"
                                                                onChange={this.handleChange}
                                                                value={this.state.min_age}
                                                                placeholder="4 to 17 years"
                                                                className="form-control" />
                                                            {this.validator.message('Age Group', this.state.min_age, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.number_of_trainee != this.state.number_of_trainee) && 'edited-field'}>
                                                                Number of Coaches<span className="astrick">*</span></label>
                                                            <input type="text" name="number_of_trainee"
                                                                onChange={this.handleChange}

                                                                value={this.state.number_of_trainee}
                                                                className="form-control" />
                                                            {this.validator.message('Number of Coaches', this.state.number_of_trainee, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <div>
                                                                <label
                                                                    className={edited &&
                                                                        ((edited_data.from_time != this.state.from_time) || (edited_data.from_time_cate != this.state.from_time_cate))
                                                                        && 'edited-field'}>From Timing</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.from_time}
                                                                        name="from_time"
                                                                        title='Select'
                                                                    >
                                                                        {this.state.timingList.length > 0 &&
                                                                            this.state.timingList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.id} >
                                                                                        {item.timing}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message('Timing', this.state.from_time, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <label>&nbsp;</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.from_time_cate}
                                                                        name="from_time_cate"
                                                                    >
                                                                        <option value="AM">AM</option>
                                                                        <option value="PM">PM</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <div>
                                                                <label
                                                                    className={edited &&
                                                                        ((edited_data.to_time != this.state.to_time) || (edited_data.to_time_cate != this.state.to_time_cate))
                                                                        && 'edited-field'}>To Timing</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.to_time}
                                                                        name="to_time"
                                                                        title='Select'
                                                                    >
                                                                        {this.state.timingList.length > 0 &&
                                                                            this.state.timingList.map((item, i) => {
                                                                                return (
                                                                                    <option value={item.id} >
                                                                                        {item.timing}
                                                                                    </option>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    {this.validator.message('Timing', this.state.to_time, 'required', { className: 'text-danger' })}
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <label>&nbsp;</label>
                                                                <div className="custom-select-drop dropdown">
                                                                    <select
                                                                        className="form-control selectpicker"
                                                                        onChange={this.handleSelect}
                                                                        value={this.state.to_time_cate}
                                                                        name="to_time_cate"
                                                                    >
                                                                        <option value="AM">AM</option>
                                                                        <option value="PM">PM</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.est_year != this.state.establishment_Year) && 'edited-field'}>
                                                                Establishment Year <span className="astrick">*</span></label>
                                                            <input type="text" name="establishment_Year"
                                                                value={this.state.establishment_Year}
                                                                onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.avg_fee != this.state.avg_anual_fee) && 'edited-field'}>
                                                                Average Fees(INR) <span className="astrick">*</span></label>
                                                            <input type="text" name="avg_anual_fee"
                                                                value={this.state.avg_anual_fee}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Average Fees', this.state.avg_anual_fee, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.admit_fee != this.state.addmission_fee) && 'edited-field'}>
                                                                Admission Fees <span className="astrick">*</span></label>
                                                            <input type="text" name="addmission_fee"
                                                                value={this.state.addmission_fee}
                                                                onChange={this.handleChange} className="form-control" />
                                                            {this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })}
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.std_ratio != this.state.std_ratio) && 'edited-field'}>
                                                                Student Ratio<span className="astrick">*</span></label>
                                                            <div className="custom-select-drop dropdown">
                                                                <select
                                                                    value={this.state.std_ratio}
                                                                    name="std_ratio"
                                                                    id="std_ratio"
                                                                    onChange={this.handleSelect}
                                                                    className="form-control selectpicker"
                                                                    multiple
                                                                    title='Select'
                                                                >
                                                                    <option value='1' >
                                                                        One to One
                                                                    </option>
                                                                    <option value='2' >
                                                                        One to Many
                                                                    </option>
                                                                    <option value='3' >
                                                                        NA
                                                                    </option>
                                                                </select>
                                                                {this.validator.message('Admission Fees', this.state.addmission_fee, 'required', { className: 'text-danger' })}
                                                            </div>
                                                        </div>
                                                        <div class="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.has_trail != this.state.has_trail) && 'edited-field'}>
                                                                Is Free Trial Available? <span class="astrick">*</span></label>
                                                            <select
                                                                className='form-control selectpicker'
                                                                name='has_trail'
                                                                value={this.state.has_trail}
                                                                title='Select'
                                                                onChange={this.handleSelect}>
                                                                <option value='0'>NA</option>
                                                                <option value='1'>Yes</option>
                                                                <option value='2'>No</option>
                                                            </select>
                                                            {this.validator.message('Free Trial', this.state.has_trail, 'required', { className: 'text-danger error-msg' })}

                                                        </div>
                                                        {(this.state.has_trail == 1 && (
                                                            <div class="form-group col-md-4">
                                                                <label
                                                                    className={edited && (edited_data.trail_desc != this.state.trail_desc) && 'edited-field'}>
                                                                    Free Trial Description <span class="astrick">*</span></label>
                                                                <textarea className="form-control" name='trail_desc' onChange={this.handleChange} value={this.state.trail_desc}></textarea>
                                                                {this.validator.message('Free Trial Descrption', this.state.trail_desc, 'required', { className: 'text-danger error-msg' })}
                                                            </div>
                                                        ))}
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.keywords != this.state.keywords) && 'edited-field'}>
                                                                Keywords<span className="astrick">*</span></label>

                                                            <Multiselect
                                                                isObject={false}
                                                                options={this.state.keywordsArr} // Options to display in the dropdown
                                                                selectedValues={this.state.keywords} // Preselected value to persist in dropdown
                                                                onSelect={this.onSelect} // Function will trigger on select event
                                                                onRemove={this.onRemove} // Function will trigger on remove event
                                                            />
                                                            {/* <textarea
                                                                name="keywords"
                                                                value={this.state.keywords}
                                                                onChange={this.handleChange}
                                                                className="form-control"
                                                                placeholder="ex: school,category names,location name,etc"
                                                            ></textarea> */}
                                                            {/* {this.validator.message('Website Search Keywords', this.state.keywords, 'required', { className: 'text-danger' })} */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label
                                                                className={edited && (edited_data.images != this.state.images) && 'edited-field'}>
                                                                Banner Image <span className="astrick">*</span>
                                                            </label>
                                                            <input
                                                                type="file"
                                                                name="images"
                                                                onChange={this.handleFile}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        {(this.state.edit_image != '' || this.state.tempBanner != '') &&
                                                            (
                                                                <div class="col-md-2 col-sm-12 mar-btm" id="edit_image">

                                                                    <img src={this.state.tempBanner ? this.state.tempBanner : this.state.edit_image} alt="Img" class="img-thumbnail" />

                                                                </div>
                                                            )
                                                        }
                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label
                                                                className={edited && (edited_data.photos != this.state.photos) && 'edited-field'}>
                                                                Gallery Images <span className="astrick">*</span>
                                                            </label>
                                                        </div>

                                                        <div class="col-md-12 float-left mt-4 p-0">

                                                            <div class="col-md-12 margin-bottom-mobile-account float-left image-upload">
                                                                {/* <span class="col-md-12 account-details-text float-left p-0">Image</span> */}
                                                                <div className='upload-wizard'>
                                                                    <div className='upload-thumb'>
                                                                        <ul className='list-inline'>
                                                                            {this.state.attachment_file.map((file_data, index) => {


                                                                                var file_url;
                                                                                if (file_data.name) {
                                                                                    let url = file_data.image_thumb ? file_data.image_thumb : '';
                                                                                    if (url != '') {
                                                                                        file_url = file_data.image_thumb;
                                                                                    } else {
                                                                                        file_url = URL.createObjectURL(file_data);
                                                                                    }
                                                                                    // var file_url = URL.createObjectURL(file_data)
                                                                                    // var file_name = file_data.name
                                                                                    if (file_data.type === 'application/pdf') {
                                                                                        var blob = file_url
                                                                                        //console.log('blob_url', file_data.name)
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_name}</span> */}
                                                                                                <a href='javascript:;' className='del-btn' onClick={() => {
                                                                                                    this.removeImage(file_data.name)
                                                                                                }}>
                                                                                                    <img
                                                                                                        src={'../../../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <li className='previewImg'>
                                                                                                <div className='thumb-img'>
                                                                                                    <img
                                                                                                        src={file_url}
                                                                                                        alt='image'
                                                                                                        title={file_data.name}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* <span className='file-name'>{file_data.name}</span> */}
                                                                                                <a
                                                                                                    href='javascript:;'
                                                                                                    className='del-btn'
                                                                                                    onClick={() => {
                                                                                                        this.removeImage(file_data.name)
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={'../../../assets/images/close-icon-white.svg'}
                                                                                                        alt='delete'
                                                                                                    />
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            })}
                                                                            <li className='addMore'>
                                                                                <input
                                                                                    type='file'
                                                                                    name='imgInp[]'
                                                                                    id='imgInp2'
                                                                                    className='add_img'
                                                                                    multiple
                                                                                    onChange={this.loadFile.bind(this)}
                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                />
                                                                                <a href='javascript:;' className='add-more'>
                                                                                    <div>
                                                                                        <img src={'../../../assets/images/upload-icon.svg'} alt='icon' />
                                                                                        Add more
                                                                                    </div>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                                {this.validator.message('gallery images', this.state.attachment_file, '', { className: 'text-danger error-msg' })}
                                                                {/* {this.validator.message('gallery images', this.state.attachment_file, 'required', { className: 'text-danger error-msg' })} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-xs-12 btn-bdr">
                                                    <button id="btnSubmit" className="btn btn-primary btn-sm">Preview</button>
                                                </div>
                                            </form>


                    </div>
                  </div>
                </div>
              </div>  


                </div>
              </div>
            </div>

             {this.preview()}

            </AdminLayout>
               
      </React.Fragment >
    );
  }
  
preview = () => {
        let subcate = this.state.categoryTypeList.map((item) =>
            this.state.sub_categories.includes(item.category_id.toString()) ? item.category_name : ''
        );
        subcate = subcate.filter(n => n).toString();
        let ttype = this.state.tutionList.map((item) =>
            this.state.tution_type.includes(item.id.toString()) ? item.name : ''
        );
        ttype = ttype.filter(n => n).toString();
        let loptions = this.state.std_ratio.map((item) => {
            if (item == 1) {
                return 'One to One';
            }
            if (item == 2) {
                return 'One to Many';
            }
            if (item == 3) {
                return 'NA';
            }
        }
        );
        loptions = loptions.filter(n => n).toString();
        let clsfreq = this.state.ClassList.map((item) => {
            if (this.state.class_frequency == item.id.toString())
                return item.freq_name;
        });
        let from_time = this.state.timingList.map((item) => {
            if (item.id == this.state.from_time) return item.timing
        })
        from_time = from_time.filter(n => n).toString();
        let to_time = this.state.timingList.map((item) => {
            if (item.id == this.state.to_time) return item.timing
        })
        to_time = to_time.filter(n => n).toString();
        return (
            <Modal isOpen={this.state.preview} size='lg' className='preview-pop'>
                <ModalBody className='p-0'>
                    <Row>
                        <Col md='12'>
                            <img src='/assets/images/user-header.png' className='preview-header' />
                        </Col>
                    </Row>
                    <Row className='pv-banner'>
                        <Col className='pv-banner-bg' md='12'>
                            <div className='title-section'>
                                <p className="banner-title">{this.state.organisation_name}</p>
                                <p className="banner-address">{this.state.address}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>About the School</h4>
                                <p className="">{this.state.about}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Key Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Sub Category</b></div>
                                        <div className='key-po'>
                                            <p>{subcate}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Number of Coach</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {this.state.number_of_trainee}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Timing</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {from_time == 'NA' || to_time == 'NA' ? 'NA' :
                                                    `${from_time} ${this.state.from_time_cate} - ${to_time} ${this.state.to_time_cate}`}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Type</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {ttype}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Class Frequency</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {clsfreq}
                                            </p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Age Group</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.min_age}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Establishment Year</b></div>
                                        <div className='key-po'>
                                            <p>{this.state.establishment_Year}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Avg Fee</b></div>
                                        <div className='key-po'>
                                            <p>{parseFloat(this.state.avg_anual_fee) > 0 ? `${this.state.avg_anual_fee}/Month` : 'NA'}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Admission Fee</b></div>
                                        <div className='key-po'>
                                            <p>{parseFloat(this.state.admit_fee) > 0 ? `${this.state.admit_fee}` : 'NA'}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Learning Options</b></div>
                                        <div className='key-po'>
                                            <p>{loptions}</p>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='type-n7ngd'><b>Free Trial Class</b></div>
                                        <div className='key-po'>
                                            <p>
                                                {this.state.has_trail == 0 ? 'NA' :
                                                    (this.state.has_trail == 1 ? 'Yes, ' : 'No')}
                                                {this.state.has_trail == 1 && (` ${this.state.trail_desc}`)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Gallery</h4>
                                <div className='row'>
                                    {this.state.attachment_file.map((item) => {
                                        if (item.image_thumb) {
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={item.image_thumb} className='preview-image' />
                                                </div>
                                            )
                                        } else if (item.name) {
                                            let file_url = URL.createObjectURL(item);
                                            return (
                                                <div className='col-md-4'>
                                                    <img src={file_url} className='preview-image' />
                                                </div>
                                            )
                                        }
                                    })}
                                    {this.state.attachment_file.length === 0 && (
                                        <div className='col-md-4'>No Gallery Images Found</div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <div className='title-section'>
                                <h4>Contact Information</h4>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        Email Id : {this.state.email_id}
                                    </div>
                                    <div className='col-md-4'>
                                        Contact : {this.state.phone_number}
                                    </div>
                                    <div className='col-md-4'>
                                        Website : {this.state.website}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleSubmit}>
                                {this.state.edited && (this.state.role == 1 || this.state.login_id == 936) ? 'Approve' : 'Submit'}
                            </button>
                            {this.state.edited && (this.state.role == 1 || this.state.login_id == 936) && (
                                <button className='btn btn-sm btn-danger custome-submit' style={{ marginLeft: '10px' }}
                                    onClick={this.handleReject}>
                                    Reject
                                </button>
                            )}
                            <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                                onClick={() => { this.setState({ preview: false }) }}>Close</button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal >
        )
    }
    handleReject = (e) => {
        e.preventDefault();
        let req = JSON.stringify({
            id: this.token
        })
        let toastr = '';
        hobbiesReject(req).then((res => {
            if (res.status === 1) {
                toastr = window.toastr.success;
                toastr('success', {
                    positionClass: "toast-bottom-right",
                    containerId: "toast-bottom-right"
                });
                window.location.href = document.referrer;
            }
        }))
    }
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            let insData = {
                id: this.token ? this.token : '',
                about: this.state.about,
                admit_fee: this.state.addmission_fee,
                address: this.state.address,
                area: this.state.area,
                avg_fee: this.state.avg_anual_fee,
                category: this.state.category,
                class_frequency: this.state.class_frequency,
                country: this.state.country,
                email_id: this.state.email_id,
                est_year: this.state.establishment_Year,
                google_location: this.state.google_location,
                location: this.state.location,
                min_age: this.state.min_age,
                std_ratio: this.state.std_ratio,
                // modeofpayment: this.state.modeofpayment,
                number_of_trainee: this.state.number_of_trainee,
                organisation_name: this.state.organisation_name,
                phone_number: this.state.phone_number,
                images: this.state.images,
                photos: this.state.attachment_file,
                pincode: this.state.pincode,
                registration_no: this.state.registration_no,
                state: this.state.state,
                sub_categories: this.state.sub_categories,
                sub_types: this.state.sub_types,
                sub_type: this.state.sub_type,
                timing: this.state.timing,
                video_leaning: this.state.video_leaning,
                website: this.state.website,
                tution_type: this.state.tution_type,
                partner_type: this.state.partner_type,
                other_info: this.state.other_info,
                login_id: this.state.login_id,
                latitude: this.state.latitude,
                longitude: this.state.longitude,
                other_rating: this.state.other_rating,
                from_time: this.state.from_time,
                to_time: this.state.to_time,
                from_time_cate: this.state.from_time_cate,
                to_time_cate: this.state.to_time_cate,
                keywords: this.state.keywords ? this.state.keywords.join(';') : '',
                delete_array: this.state.delete_array,
                has_trail: this.state.has_trail,
                trail_desc: this.state.trail_desc,
                role: this.state.role
            }
            // jQuery("#btnSubmit").attr('disabled', true);
            AddSports(insData).then((res) => {
                let toastr = '';
                if (res.status === 1) {
                    toastr = window.toastr.success;
                    toastr('success', 'created success!..', {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                    //window.location.href = document.referrer;
                } else {
                    jQuery("#btnSubmit").attr('disabled', false);
                    toastr = window.toastr.error; //warning
                    toastr('Error', 'Something went wrong. try again!...', {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };


}

export default verticalCampsEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalCampsEdit.jsx